import { Name as EntityName } from '../../entity';

export const TYPE = `${EntityName.ACTION_PREFIX}BROWSER:scroll_window`;

export interface Payload {
    to?: string;
    toAnchor?: string;
}
